import { useEffect } from 'react';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
}: SEOMetaProps) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} - 星空传媒`;

    const setMeta = (name: string, content: string, property?: string) => {
      let element: HTMLMetaElement | null = null;
      if (property) {
        element = document.querySelector(`meta[property="${property}"]`);
      } else {
        element = document.querySelector(`meta[name="${name}"]`);
      }

      if (!element) {
        element = document.createElement('meta');
        if (property) {
          element.setAttribute('property', property);
        } else {
          element.setAttribute('name', name);
        }
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    if (ogTitle) setMeta('og:title', ogTitle, 'og:title');
    if (ogDescription) setMeta('og:description', ogDescription, 'og:description');
    if (ogImage) setMeta('og:image', ogImage, 'og:image');

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalUrl) {
      if (!canonicalEl) {
        canonicalEl = document.createElement('link');
        canonicalEl.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalEl);
      }
      canonicalEl.setAttribute('href', canonicalUrl);
    }

    return () => {
      document.title = previousTitle;
    };
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogImage]);

  return null;
}